export default __webpack_public_path__ + "static/media/audio2.a977a111.svg";